import React, { useEffect, useState, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import DivLayout from 'components/sales/divLayout/divLayout';
import ICardSection from 'components/sales/cardSection/iCardSection';
import DocumentView from 'components/sales/downloadDocView/documentView';

const ConfirmationItration = ({
  keyValue=null,   
  data=null,
  filesData=null
}) => {
    console.log('d-data ' + JSON.stringify(filesData)); 
  return (
   <>
   <ICardSection title={`Iteration ${keyValue+1}`}> 
   <div className="details-listing dl-view">
      <DivLayout
          heading={localization.status}
          data={filesData?.status}
      />
      <DivLayout
          heading={localization.remark}
          data={filesData?.remark}
      />
      <DivLayout
          heading={localization.vendorName}
          data={filesData?.vendor_name}
      />
      <DivLayout
          heading={localization.createdBy}
          data={filesData?.pr_raised_by}
      />
      {/* {filesData?.mb_sheet_doc ? (
      <div className={'details-list'} > 
       <DocumentView title={`MB Sheet`} attachment={filesData?.mb_sheet_doc} />
      </div>
      ) : null}
      {filesData?.wcc_doc ? (
      <div className={'details-list'} > 
       <DocumentView title={`WCC Document`} attachment={filesData?.wcc_doc} />
      </div>
      ) : null}
      {filesData?.invoice_doc ? (
      <div className={'details-list'} > 
       <DocumentView title={`Invoice`} attachment={filesData?.invoice_doc} />
      </div> 
      ) : null}
      {filesData?.other_doc && filesData?.other_doc.length > 0 && filesData?.other_doc.map((item,key) => {
        return (
          <div className={'details-list'} > 
           <DocumentView title={`Other Document ${key + 1}`} attachment={item} />
          </div>
        )
      })} */}
   </div>           
   <div className='card-body'> 
   <table className='table table-bordered'>
    <thead>
        <tr>
        <th>Service</th>
        <th>Requested Qty</th>
        <th>Actual Qty</th>
        </tr>
        </thead> 
        <tbody>
        {data.map((item,val) => {  
            return (
            <tr>
                <td>{item['service_name']}</td>
                <td>{item['requested_qty']}</td>
                <td>{item['actual_qty']}</td>
            </tr> 
            )
        })} 
      </tbody> 
    </table>  
    </div>
   </ICardSection>
   </>
  );
};
export default ConfirmationItration;
